<lib-pauly-checkbox [formControl]="$any(limitCtrl)" [label]="limitLabel" [info]="limitInfo"></lib-pauly-checkbox>

@if (isLimited) {
  <div class="row mt-3">
    <div class="form-field-container col-12 col-md-6">
      <div class="form-field-label">
        <span class="required-label">{{ periodTypeLabel }}</span>
      </div>
      <lib-select
        [translation]="true"
        [options]="periodTypeOptions"
        [value]="periodTypeCtrl?.value"
        (valueChange)="onPeriodTypeChange($event)"
      ></lib-select>
    </div>
  </div>
  <!-- Duration period: quantity input -->
  @if (isDuration) {
    <div class="row mt-3">
      <div class="form-field-container col-12 col-md-6">
        <div class="form-field-label">
          <span class="required-label">{{ quantityLabel }}</span>
        </div>
        <mat-form-field class="form-field" [floatLabel]="'auto'">
          <input matInput type="number" [formControl]="$any(quantityCtrl)" min="1" />
          @if (quantityCtrl?.hasError('required')) {
            <mat-error>{{ requiredError }}</mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }
  <!-- Fixed dates: start + finish pickers -->
  @if (isFixedDates) {
    <div class="row mt-3">
      <div class="form-field-container col-12 col-md-6">
        <div class="form-field-label">
          <span class="required-label">{{ startLabel }}</span>
          @if (startInfo) {
            <span
              class="info-icon ml-2 dashboard-tooltip"
              matTooltipClass="dig-tooltip"
              #tooltipStart="matTooltip"
              (click)="tooltipStart.toggle()"
              [matTooltip]="startInfo"
            >
              <span inlineSVG="/icons/icon-info-circle-v2.svg"></span>
            </span>
          }
        </div>
        @if (mode === 'datetime') {
          <lib-date-time-field [formControl]="$any(startCtrl)" [stepMinute]="1">
            @if (startCtrl?.hasError('required')) {
              <mat-error>{{ requiredError }}</mat-error>
            }
          </lib-date-time-field>
        }
        @if (mode === 'date') {
          <mat-form-field class="form-field" [floatLabel]="'auto'">
            <input matInput type="date" [formControl]="$any(startCtrl)" autocomplete="off" />
            @if (startCtrl?.hasError('required')) {
              <mat-error>{{ requiredError }}</mat-error>
            }
          </mat-form-field>
        }
      </div>
      <div class="form-field-container col-12 col-md-6">
        <div class="form-field-label">
          <span class="required-label">{{ finishLabel }}</span>
          @if (finishInfo) {
            <span
              class="info-icon ml-2 dashboard-tooltip"
              matTooltipClass="dig-tooltip"
              #tooltipFinish="matTooltip"
              (click)="tooltipFinish.toggle()"
              [matTooltip]="finishInfo"
            >
              <span inlineSVG="/icons/icon-info-circle-v2.svg"></span>
            </span>
          }
        </div>
        @if (mode === 'datetime') {
          <lib-date-time-field [formControl]="$any(finishCtrl)" [stepMinute]="1" [defaultTime]="[23, 59, 59]">
            @if (finishCtrl?.hasError('required')) {
              <mat-error>{{ requiredError }}</mat-error>
            }
          </lib-date-time-field>
        }
        @if (mode === 'date') {
          <mat-form-field class="form-field" [floatLabel]="'auto'">
            <input matInput type="date" [formControl]="$any(finishCtrl)" autocomplete="off" />
            @if (finishCtrl?.hasError('required')) {
              <mat-error>{{ requiredError }}</mat-error>
            }
          </mat-form-field>
        }
      </div>
    </div>
  }
}
